import { z } from 'zod';

export const createPagingApiResponseSchema = <T extends z.ZodTypeAny>(itemSchema: T) =>
  z.object({
    list: z.array(itemSchema),
  });

export const createApiResponseSchema = <T extends z.ZodTypeAny>(dataSchema: T) =>
  z.object({
    data: dataSchema,
    meta: z.object({
      result: z.enum(['FAIL', 'SUCCESS']),
      errorCode: z.string().nullable(),
      message: z.string().nullable(),
    }),
    link: z
      .object({
        next: z.string().nullable().optional(),
        prev: z.string().nullable().optional(),
        total: z.number().nullish(),
      })
      .optional()
      .nullable(),
  });
